import React, { createContext, useContext, useMemo, useState } from 'react';

import { IContext } from './types/context';
import { TStationRoutePoint, RouteSettings, TStartPoint } from './types';
import { IValue } from 'common/hooks/useCheckboxState';

interface Props {
  children: React.ReactNode;
}

export const RouteContext = createContext({} as IContext);
export const useRouteContext = () => useContext(RouteContext);

const RouteProvider = ({ children }: Props) => {
  const [stationRoutePoint, setStationRoutePoint] = useState<TStationRoutePoint>();
  const [routeModifiers, setRouteModifiers] = useState<IValue>({});
  const [routeSettings, setRouteSettings] = useState<RouteSettings>({});
  const [startPoint, setStartPoint] = useState<TStartPoint>();

  const value = useMemo(
    () => ({
      stationRoutePoint,
      setStationRoutePoint,

      routeModifiers,
      setRouteModifiers,

      routeSettings,
      setRouteSettings,

      startPoint,
      setStartPoint,
    }),
    [
      stationRoutePoint,
      setStationRoutePoint,

      routeModifiers,
      setRouteModifiers,

      routeSettings,
      setRouteSettings,

      startPoint,
      setStartPoint,
    ]
  );

  return <RouteContext.Provider value={value}>{children}</RouteContext.Provider>;
};

export default RouteProvider;
